/* eslint-disable */
import React, { useState, useContext, useMemo, useEffect } from "react";
// Examples of imports of components and styles you already have in the project

import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer";
import CardContent from "@material-ui/core/CardContent";
import GridItem from "components/Grid/GridItem";
import KpiRotatingCard from "./AuxComponents/KPIRotating.js";
import OverviewTable from "./AuxComponents/OverviewTable.js";
import CardHeader from "../../../components/Card/CardHeader.js";
import Card from "../../../components/Card/Card.js";
import Button from "components/CustomButtons/Button";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import MultiSeriesLineChart from "./AuxComponents/MultiSeriesLineChart.js";
import Tooltip from "@material-ui/core/Tooltip";
import EditSectionModal from "../../../components/EditSectionModal/EditSectionModal.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarPlus,
  faCalendarMinus,
  faTable,
  faChartLine,
  faExclamationTriangle,
  faFilter,
} from "@fortawesome/free-solid-svg-icons";
import CardBody from "components/Card/CardBody.js";
import dayjs from "dayjs";

import {
  Announcement,
  DoubleArrow,
  Visibility,
  Edit,
  AssignmentTurnedIn,
  AttachMoney,
  Info,
} from "@material-ui/icons";
import CardIcon from "components/Card/CardIcon.js";
import CardFooter from "components/Card/CardFooter.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import AuthContext from "contexts/AuthProvider.js";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
import { grayColor } from "assets/jss/material-dashboard-pro-react.js";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { useTranslation } from "react-i18next";
import { formatThresholds } from "utils/thresholdUtils"; // important function to create dynamic texts to explain each KPIs threshold for colors

import { Checkbox, FormControlLabel } from "@material-ui/core";
import { CheckCircle, RadioButtonUnchecked } from "@material-ui/icons";
import { client } from "../../../services/axiosClient";
import { ThreeDots } from "react-loader-spinner";
import MultiSeriesLineChartvBAR from "./AuxComponents/MultiSeriesLineChartvBAR.js";

import Typography from "views/Components/Typography.js";
// If you want to use the loading spinner:

const INITIATIVES_MOCK = [
  {
    id: "101",
    branch: "Branch A",
    workfront: "Workfront X",
    initiative: "Iniciativa XPTO",
    approvalGates: [
      { gateName: "Gate 1", approved: true, approvers: ["Alice"] },
      { gateName: "Gate 2", approved: false, approvers: ["Bob", "Carol"] },
    ],
    lastOnePageUpdate: "2 days ago",
    lastImplementationPlanUpdate: "2 weeks ago",
    lastPlannedResultsUpdate: "1 month ago",
  },
  {
    id: "102",
    branch: "Branch B",
    workfront: "Workfront Y",
    initiative: "Iniciativa ABC",
    approvalGates: [
      { gateName: "Gate 1", approved: true, approvers: ["Dan", "Erin"] },
      { gateName: "Gate 2", approved: true, approvers: ["Frank"] },
    ],
    lastOnePageUpdate: "3 days ago",
    lastImplementationPlanUpdate: "4 days ago",
    lastPlannedResultsUpdate: "2 days ago",
  },
];

// Function to render priority chip

import { Chip } from "@material-ui/core";

function getPriorityChip(priority) {
  switch (priority) {
    case "High":
      return (
        <Chip
          label="HIGH"
          style={{
            backgroundColor: "#f44336", // Red

            color: "#fff",
            fontWeight: "bold",
          }}
          size="small"
        />
      );
    case "Medium":
      return (
        <Chip
          label="MEDIUM"
          style={{
            backgroundColor: "#ffeb3b", // Yellow

            color: "#333",
            fontWeight: "bold",
          }}
          size="small"
        />
      );
    case "Low":
      return (
        <Chip
          label="LOW"
          style={{
            backgroundColor: "#4caf50", // Green

            color: "#fff",
            fontWeight: "bold",
          }}
          size="small"
        />
      );
    default:
      return (
        <Chip
          label="UNDEFINED"
          style={{
            backgroundColor: "#9e9e9e",
            color: "#fff",
          }}
          size="small"
        />
      );
  }
}

// ----Main component -----------------------------------------

export default function WhatsHappening() {
  const { userDetails } = useContext(AuthContext);
  const clientColor = userDetails?.implementation_color;

  // Unified KPI object for "Captura"

  const kpiCaptura = useMemo(
    () => ({
      title: "Captura",
      trackingMode: "ASC", // Adjust If Needed

      thresholdsConfig: {
        greenRange: [1.0, Infinity],
        yellowRange: [0.8, 1.0],
        redRange: [0, 0.8],
      },
      data: {
        monthly: {
          labels: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun"],
          series: [
            [100, 110, 120, 130, 160, 180], // Goal

            [90, 105, 95, 110, 150, null], // REALIZED

            [null, null, null, null, 150, 190], // Projection
          ],
          seriesNames: ["Meta", "Realizado", "Projeção"],
        },
        yearly: {
          labels: ["2022", "2023", "2024", "2025", "2026"],
          series: [
            [2000, 2500, 3000, 3500, 4000], // Goal

            [1800, 2100, 2500, 3200, null], // REALIZED

            [null, null, null, 3200, 4500], // Projection
          ],
          seriesNames: ["Meta", "Realizado", "Projeção"],
        },
      },
    }),
    []
  );

  // UNIFIED KPI Object for "Execution"

  const kpiExecucao = useMemo(
    () => ({
      title: "Execução",
      trackingMode: "ASC", // Adjust If Needed (or "des")

      thresholdsConfig: {
        greenRange: [1.0, Infinity],
        yellowRange: [0.8, 1.0],
        redRange: [0, 0.8],
      },
      data: {
        monthly: {
          labels: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun"],
          series: [
            [80, 90, 100, 110, 120, 130], // Goal Execution

            [70, 85, 95, 90, 85, null], // Executed

            [null, null, null, null, 85, 75], // Projection Execution
          ],
          seriesNames: ["Meta", "Realizado", "Projeção"],
        },
        yearly: {
          labels: ["2022", "2023", "2024", "2025", "2026"],
          series: [
            [1600, 1800, 2000, 2200, 2500], // Goal Execution

            [1400, 1700, 1900, 2300, null], // Executed

            [null, null, null, 2300, 2500], // Projection Execution
          ],
          seriesNames: ["Meta", "Realizado", "Projeção"],
        },
      },
    }),
    []
  );

  // ----STATE MANAGEMENT //  

  const [sections, setSections] = useState([]);
  const [selectedSectionId, setSelectedSectionId] = useState(null); // Default for section "2"

  const [decisions, setDecisions] = useState([]);
  const [initiatives] = useState(INITIATIVES_MOCK);

  const handleDecisionToggle = async (decisionId, checked) => {
    try {
      const payload = {
        action: "updateDecision",
        id: decisionId,
        done: checked,
      };
      const response = await client.post(
        "/api/control-panel-sections-decisions/",
        payload
      );
      if (response.status !== 200) {
        throw new Error("Failed to update decision");
      }
      const data = response.data;
      if (data.success) {
        // Atualiza local
        setDecisions((prev) =>
          prev.map((dec) =>
            dec.id === decisionId ? { ...dec, done: checked } : dec
          )
        );
      } else {
        console.error("API error:", data.error);
      }
    } catch (error) {
      console.error("Error toggling decision:", error);
    }
  };

  // Separate states for each chart

  const [timeAggCaptura, setTimeAggCaptura] = useState("monthly");
  const [timeAggExecucao, setTimeAggExecucao] = useState("monthly");

  // new states for chart/table

  const [viewModeCaptura, setViewModeCaptura] = useState("chart");
  const [viewModeExecucao, setViewModeExecucao] = useState("chart");

  // States for the editing modal

  const [isModalOpen, setIsModalOpen] = useState(false);

  // Functions to switch between "Monthly" and "Yearly" for each chart

  const toggleTimeAggCaptura = () => {
    setTimeAggCaptura((prev) => (prev === "monthly" ? "yearly" : "monthly"));
  };

  const toggleTimeAggExecucao = () => {
    setTimeAggExecucao((prev) => (prev === "monthly" ? "yearly" : "monthly"));
  };

  const toggleViewModeCaptura = () => {
    setViewModeCaptura((prev) => (prev === "chart" ? "table" : "chart"));
  };
  const toggleViewModeExecucao = () => {
    setViewModeExecucao((prev) => (prev === "chart" ? "table" : "chart"));
  };

  // Functions to open and close the modal

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // States for overviewtable

  const [viewModeOverview, setViewModeOverview] = useState("table");

  const toggleViewModeOverview = () => {
    setViewModeOverview((prev) => (prev === "table" ? "stages" : "table"));
  };

  // Functions within the main component

  // ====== Render Floating Card ======

  const renderFloatingCard = () => {
    const selectedSection = sections.find((s) => s.id === selectedSectionId);
    if (!selectedSection) return null;

    return (
      <div className={classes.floatingCard}>
        <div className={classes.floatingCardTitle}>
          {selectedSection.section_name}
        </div>
        {/* Edit button */}
        <Tooltip title={t("whatshappening.buttons.edit_section")}>
          <Edit
            className={classes.iconButtonCustom}
            onClick={handleOpenModal}
            style={{
              cursor: "pointer",
              fontSize: "20px",
            }}
          />
        </Tooltip>
        {/* Modal to select new section */}
        <EditSectionModal
          open={isModalOpen}
          handleClose={handleCloseModal}
          sections={sections}
          setSelectedSectionId={setSelectedSectionId}
          clientColor={clientColor} // <= Pass the color
        />
      </div>
    );
  };

  // ------------------------------------------------------

  const WhatsHappeningStyles = (theme, clientColor) => ({
    ...customSelectStyle(theme, clientColor),
    ...customInputStyle(clientColor),

    root: {
      padding: 0, // Removing Padding to get more compact

      margin: 0, // Removing Margin
    },
    tabsRoot: {
      backgroundColor: grayColor[8],
    },
    tabRoot: {
      fontSize: "1rem",
      fontWeight: 400,
      color: clientColor,
      textTransform: "none",
      "&:hover": {
        color: clientColor,
        opacity: 1,
      },
      "&.Mui-selected": {
        color: "black",
        fontWeight: 500,
        borderBottom: `2px solid ${clientColor}`,
      },
      "&:focus": {
        color: clientColor,
      },
    },
    indicator: {
      backgroundColor: clientColor,
      height: "1.5px",
    },
    cardIconTitle: {
      ...cardTitle,
      marginTop: "0px",
      marginBottom: "0px",
      padding: "10px",
    },
    addButton: {
      marginBottom: theme.spacing(2),
      height: "22px !important",
      width: "30px !important",
      minWidth: "0 !important",
      position: "relative",
      transition: "all 0.2s",
      margin: "10px 0 0 10px !important",
      padding: "0 !important",
    },
    cardButton: {
      padding: "0 !important",
      margin: "0 !important",
      height: "30px !important",
      width: "30px !important",
      minWidth: "0 !important",
      position: "relative",
      transition: "all 0.2s",
    },
    cardButtonIcon: {
      margin: "0 !important",
      position: "absolute !important",
      top: "50% !important",
      left: "50% !important",
      transform: "translate(-50%, -50%)",
      width: "18px !important",
      height: "18px !important",
    },
    iconButtonCustom: {
      cursor: "pointer",
      "&:hover": {
        color: clientColor,
      },
    },
    actionIconsCustom: {
      display: "flex",
      gap: theme.spacing(1),
      justifyContent: "center",
      alignItems: "center",
    },
    center: {
      textAlign: "center",
    },
    tableHeadCell: {
      fontWeight: "bold",
      backgroundColor: "white",
      cursor: "pointer",
    },
    floatingCard: {
      position: "fixed",
      top: 0, // Adjusting according to your header

      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 1200,
      backgroundColor: "#fff",
      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
      borderRadius: "0 0 8px 8px",
      padding: "6px 4px 4px 10px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      maxWidth: "90%", // On small screens, up to 90% of the width

      [theme.breakpoints.down("sm")]: {
        // On screens <Sm, push a little to the right

        position: "static",
        alignItems: "center",
        maxWidth: "100%",
        transform: "none",
        zIndex: 1200,
        borderRadius: 0, // Removes mobile Rounding

        margin: "-40px 15px 37px 0",
        backgroundColor: "#EEEE",
        borderBottom: "1px solid " + grayColor[4],
        boxShadow: "none",
      },
    },
    floatingCardTitle: {
      fontSize: "14px",
      color: "#333",
      marginRight: "10px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
      },
    },
    sortIndicator: {
      marginLeft: theme.spacing(1),
      fontSize: "0.8rem",
    },
    filterContainer: {
      marginBottom: theme.spacing(2),
      display: "flex",
      alignItems: "center",
    },
    filterItem: {
      marginRight: theme.spacing(2),
      minWidth: 200,
    },
    accordionRootCustom: {
      marginBottom: theme.spacing(0.2),
      overflow: "hidden",
      boxShadow: "none",
      "&:before": {
        display: "none",
      },
      "&:first-of-type": {
        borderRadius: "10px 10px 10px 10px",
      },
      "&:nth-of-type(2)": {
        borderRadius: "10px 10px 10px 10px",
      },
      "&:last-of-type": {
        borderRadius: "10px 10px 10px 10px",
      },
    },
    textFieldRoot: {
      "& .MuiInput-underline:before": {
        borderBottom: "1px solid #ccc",
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottom: `2px solid ${clientColor}`,
      },
      "& .MuiInput-underline:after": {
        borderBottom: `2px solid ${clientColor}`,
      },
    },
    inputText: {
      color: "#666",
      "&:focus": {
        color: "#666",
      },
    },
    labelText: {
      color: "#666",
      "&.Mui-focused": {
        color: "#666",
      },
    },
    sortIcon: {
      fontSize: "14px",
      marginLeft: "6px",
      color: "#ccc",
    },
    activeSortIcon: {
      color: "#aaa",
    },
    stats: {
      color: grayColor[0],
      fontSize: "12px",
      lineHeight: "22px",
      display: "inline-flex",
      "& svg": {
        position: "relative",
        top: "3px",
        width: "16px",
        height: "16px",
        marginRight: "5px",
      },
      "& .fab,& .fas,& .far,& .fal,& .material-icons": {
        position: "relative",
        top: "3px",
        fontSize: "16px",
        marginRight: "3px",
      },
    },
    statusCircle: {
      position: "absolute",
      top: "8px",
      right: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "30px",
      height: "30px",
      borderRadius: "50%",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      cursor: "pointer",
      // Remova qualquer "background" que depende de sections...
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    sectionList: {
      listStyle: "none",
      padding: 0,
      margin: 0,
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      maxHeight: "80vh",
      overflowY: "auto",
      borderRadius: "10px",
    },
    sectionListItem: {
      padding: theme.spacing(1),
      borderBottom: `1px solid ${clientColor}`,
      cursor: "pointer",
      "&:hover": {
        backgroundColor: `${clientColor}2A`,
      },
    },
    funnelBar: {
      // Example of gradient using clientcolor

      background: `linear-gradient(135deg, ${clientColor}33 0%, ${clientColor} 100%)`,
      color: "#fff",
      margin: "0 auto", // Horizontal

      padding: "14px 0",
      borderRadius: "6px",
      transition: "width 0.3s ease-in-out",
      boxShadow: "0 0 6px rgba(0,0,0,0.2)",
      fontWeight: "bold",
    },
  });

  const useStylesCustom = makeStyles((theme) =>
    WhatsHappeningStyles(theme, clientColor)
  );

  const classes = useStylesCustom();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  // Define selectedSection in the main scope so it can be passed to OverviewTable

  const selectedSection = sections.find((s) => s.id === selectedSectionId);

  // Extract the chart data based on the current time aggregation

  const chartDataCapture = kpiCaptura.data[timeAggCaptura];
  if (!chartDataCapture) {
    return (
      <Typography style={{ textAlign: "center" }}>
        {t("whatshappening.messages.data_unavailable")}
      </Typography>
    );
  }

  const chartDataExec = kpiExecucao.data[timeAggExecucao];
  if (!chartDataExec) {
    return (
      <Typography style={{ textAlign: "center" }}>
        Dados indisponíveis
      </Typography>
    );
  }

  // API
  // Carrega do backend
  useEffect(() => {
    async function loadSectionsAndDecisions() {
      try {
        setIsLoading(true);
        const response = await client.post(
          "/api/control-panel-sections-decisions/",
          {
            action: "list",
          }
        );
        if (response.status !== 200) {
          throw new Error("Failed to fetch sections/decisions");
        }
        const data = response.data;
        if (data.success) {
          setSections(data.sections || []);
          setDecisions(data.decisions || []);
        } else {
          console.error("API returned an error: ", data.error);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      finally {
        setIsLoading(false); // encerra spinner
      }
    }

    loadSectionsAndDecisions();
  }, []);

  // Segundo useEffect: escolher a section com end_date mais próxima de hoje
  useEffect(() => {
    if (sections.length > 0) {
      const closestSection = getClosestSectionToToday(sections);
      if (closestSection) {
        setSelectedSectionId(closestSection.id);
      } else {
        // Se nenhuma section tiver end_date, por exemplo,
        // podemos escolher a primeira como fallback:
        setSelectedSectionId(sections[0].id);
      }
    }
  }, [sections]);

  // Função auxiliar para achar a section de end_date mais próxima de hoje
  function getClosestSectionToToday(sectionsArray) {
    const today = dayjs();
    let closestSection = null;
    let minDiff = Infinity;

    for (const section of sectionsArray) {
      if (!section.end_date) {
        continue; // ignora se nao tem end_date
      }
      const diffAbs = Math.abs(dayjs(section.end_date).diff(today, "days"));
      if (diffAbs < minDiff) {
        minDiff = diffAbs;
        closestSection = section;
      }
    }

    return closestSection;
  }

  return (
    <div>
      {/* Render the floating card */}
      {renderFloatingCard()}
      <GridContainer
        spacing={0} // Defines 0 to eliminate internal spacing
        style={{ marginTop: "-40px", overflow: "hidden" }}
      >
        {/* ========== KEY MESSAGES ========== */}
        <GridItem
          xs={12}
          sm={12}
          md={5}
          style={{
            display: "flex",
            padding: 0, // Remove internal padding

            margin: 0, // External Margin External Removes
          }}
        >
          <Card
            style={{
              flex: 1,
              height: "85%",
            }}
          >
            <CardHeader
              color="client"
              icon
              style={{ position: "relative", paddingRight: "20px" }} // Space for the button in the corner
            >
              <CardIcon color="client">
                <Announcement />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("whatshappening.cards_title.program_key_messages")}
              </h4>
              {/* Status */}
              <div
                className={classes.statusCircle}
                style={{
                  background:
                    selectedSection?.status === "Green"
                      ? "linear-gradient(135deg, #66bb6a 0%, #43a047 100%)"
                      : selectedSection?.status === "Red"
                        ? "linear-gradient(135deg, #ef5350 0%, #e53935 100%)"
                        : selectedSection?.status === "Yellow"
                          ? "linear-gradient(135deg, #ffd54f 0%, #ffc107 100%)"
                          : "linear-gradient(135deg, #bdbdbd 0%, #9e9e9e 100%)",
                  boxShadow:
                    selectedSection?.status === "Green"
                      ? "0 0 10px rgba(67,160,71,0.4)"
                      : selectedSection?.status === "Red"
                        ? "0 0 10px rgba(229,57,53,0.4)"
                        : selectedSection?.status === "Yellow"
                          ? "0 0 10px rgba(255,193,7,0.4)"
                          : "0 0 10px rgba(158,158,158,0.4)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.3)";
                  e.currentTarget.style.boxShadow =
                    sections.find((s) => s.id === selectedSectionId)?.status ===
                    "Green"
                      ? "0 0 10px rgba(76,175,80,0.4)"
                      : sections.find((s) => s.id === selectedSectionId)
                            ?.status === "Red"
                        ? "0 0 10px rgba(244,67,54,0.4)"
                        : sections.find((s) => s.id === selectedSectionId)
                              ?.status === "Yellow"
                          ? "0 0 10px rgba(255,235,59,0.4)"
                          : "0 0 10px rgba(189,189,189,0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
            </CardHeader>
            {isLoading ? (
                // Se estiver carregando, exibe o spinner no centro do CardBody
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <ThreeDots
                    color={userDetails.implementation_color}
                    height={80}
                    width={80}
                    ariaLabel="loading"
                  />
                </div>
              ) : (
                <>
            <CardBody style={{ flex: 1, overflow: "auto", maxHeight: "calc(40vh - 150px)" }}>

                <PerfectScrollbar>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        sections.find((s) => s.id === selectedSectionId)
                          ?.keyMessage ||
                        t("whatshappening.messages.no_message_available"),
                    }}
                    style={{
                      fontSize: "0.8rem",
                      lineHeight: "1.5",
                      color: "#3C3C3C",
                    }}
                  />
                </PerfectScrollbar>

            </CardBody>
            <CardFooter stats>
              <GridContainer>
                <GridItem xs={6}>
                  <div className={classes.stats}>
                    {sections.find((s) => s.id === selectedSectionId)
                      ?.section_name ||
                      t("whatshappening.labels.no_section_name")}
                  </div>
                </GridItem>
                <GridItem xs={6}>
                  <div className={classes.stats}>
                    <span>
                      {t("whatshappening.card_footer.period")}
                      {sections.find((s) => s.id === selectedSectionId)
                        ?.start_date || "?"}
                      <DoubleArrow />
                      {sections.find((s) => s.id === selectedSectionId)
                        ?.end_date || "?"}
                    </span>
                  </div>
                </GridItem>
              </GridContainer>
            </CardFooter>
            </>
              )}            
          </Card>
        </GridItem>
        {/* ========== Decisions Needed =========== */}
        <GridItem
          xs={12}
          sm={12}
          md={4}
          style={{
            display: "flex",
            padding: 0,
            margin: 0,
          }}
        >
          <Card style={{ flex: 1, height: "85%" }}>
            <CardHeader color="client" icon>
              <CardIcon color="client">
                <FontAwesomeIcon icon={faExclamationTriangle} />
              </CardIcon>
              {/* Título do Card: “Decisions Needed” */}
              <h4 className={classes.cardIconTitle}>
                {t("whatshappening.cards_title.decisions_needed")}
              </h4>
            </CardHeader>

            <CardBody style={{ padding: "8px", height: "calc(30vh - 60px)" }}>
              {isLoading ? (
                // Spinner centralizado
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <ThreeDots
                    color={userDetails.implementation_color}
                    height={100}
                    width={80}
                    ariaLabel="loading"
                  />
                </div>
              ) : (
                <PerfectScrollbar>
                  {decisions
                    .filter((dec) => dec.section_id === selectedSectionId)
                    .sort((a, b) => {
                      const priorityOrder = { High: 1, Medium: 2, Low: 3 };
                      return (
                        priorityOrder[a.priority] - priorityOrder[b.priority]
                      );
                    })
                    .map((d) => {
                      const initiative = initiatives.find(
                        (i) => i.id === d.initiative_id
                      );

                      return (
                        <div
                          key={d.id}
                          style={{
                            marginBottom: "10px",
                            borderBottom: "1px solid #ccc",
                            paddingBottom: "8px",
                          }}
                        >
                                                 <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {getPriorityChip(d.priority)}
                          <strong>
                            {initiative
                              ? initiative.initiative
                              : t("whatshappening.labels.program_related")}
                          </strong>

                          {/* Checkbox to mark if the decision was “resolved/defined” */}
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={d.done}
                                onChange={(e) =>
                                  handleDecisionToggle(d.id, e.target.checked)
                                }
                                icon={
                                  <RadioButtonUnchecked
                                    style={{ color: "#aaa" }}
                                  />
                                }
                                checkedIcon={
                                  <CheckCircle style={{ color: clientColor }} />
                                }
                              />
                            }
                            style={{ marginTop: "0px" }}
                          />
                        </div>

                        <div style={{ fontWeight: "bold", margin: "4px 0" }}>
                          {d.decisionTitle}
                        </div>
                        <div style={{ fontSize: "0.8rem", color: "#3C3C3C" }}>
                          {d.decisionDescription}
                        </div>
                        </div>
                      );
                    })}
                  {decisions.filter(
                    (dec) => dec.section_id === selectedSectionId
                  ).length === 0 && (
                    <p style={{ color: "#999", fontSize: "0.9rem" }}>
                      {t("whatshappening.messages.no_decisions")}
                    </p>
                  )}
                </PerfectScrollbar>
              )}
            </CardBody>
          </Card>
        </GridItem>
        {/* ========== KPI ROTATING CARD ========== */}
        <GridItem xs={12} sm={12} md={3}>
          <KpiRotatingCard />
        </GridItem>
        {/* ========== status table ========== */}
        <GridItem xs={12} sm={12} md={6} style={{ marginTop: "-25px" }}>
          <Card
            style={{
              height: "50.3vh",
            }}
          >
            <CardHeader color="client" icon>
              <CardIcon color="client">
                <Visibility />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("whatshappening.cards_title.overview")}
              </h4>
              <div
                style={{
                  position: "absolute",
                  right: "0px",
                  top: "10px",
                  zIndex: 1000,
                }}
              >
                <Tippy
                  content={
                    viewModeOverview === "table"
                      ? `${t("whatshappening.buttons.see_stages")}`
                      : `${t("whatshappening.buttons.see_overview")}`
                  }
                  arrow={true}
                  theme="light"
                >
                  <Button
                    color="client"
                    size="sm"
                    variant="outlined"
                    onClick={toggleViewModeOverview}
                    className={classes.cardButton}
                  >
                    <FontAwesomeIcon
                      icon={viewModeOverview === "table" ? faFilter : faTable}
                      className={classes.cardButtonIcon}
                    />
                  </Button>
                </Tippy>
              </div>
            </CardHeader>
            {/* Cardcontent with hidden overflow and fixed height */}
            <CardContent
              style={{
                flex: 1,
                padding: 0, // Remove padding not to create extra scroll

                overflow: "hidden", // Prevents native roll

                height: "calc(30vh - 60px)", // Adjustment to height you prefer

                position: "relative", // Allows you to position scrollbar
              }}
            >
              {/* PerfectScrollbar Controlling Rolling */}
              <PerfectScrollbar
                style={{ width: "100%", height: "100%" }}
                // If you want to enable horizontal scroll, suppress is 'false'

                options={{ suppressScrollX: false }}
              >
                <OverviewTable
                  selectedSection={selectedSection}
                  viewModeOverview={viewModeOverview}
                />
              </PerfectScrollbar>
            </CardContent>
          </Card>
        </GridItem>
        {/* ========== Graphs ========== */}
        <GridItem xs={12} sm={12} md={6}>
          <GridContainer direction="column">
            <GridItem
              xs={12}
              sm={12}
              md={12}
              style={{ display: "flex", marginTop: "-25px" }}
            >
              <Card
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  height: "24vh",
                }}
              >
                <GridItem>
                  <CardHeader
                    color="client"
                    icon
                    className={classes.cardHeader}
                  >
                    <CardIcon color="client">
                      <AttachMoney />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>
                      {t("whatshappening.cards_title.graph_capture")}
                    </h4>

                    {/* Container for Info + Tippy from Mensal/Annual */}
                    <div
                      style={{
                        position: "absolute",
                        right: "40px",
                        top: "10px",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Tooltip
                        title={
                          <span
                            dangerouslySetInnerHTML={{
                              __html: formatThresholds(kpiCaptura),
                            }}
                          />
                        }
                        arrow
                      >
                        <Info
                          style={{
                            fontSize: "18px",
                            color: "#666",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                      <Tippy
                        content={
                          timeAggCaptura === "monthly"
                            ? t("whatshappening.buttons.view_yearly")
                            : t("whatshappening.buttons.view_monthly")
                        }
                        arrow={true}
                        theme="light"
                      >
                        <Button
                          color="client"
                          size="small"
                          variant="outlined"
                          onClick={toggleTimeAggCaptura}
                          className={classes.cardButton}
                        >
                          <FontAwesomeIcon
                            icon={
                              timeAggCaptura === "monthly"
                                ? faCalendarPlus
                                : faCalendarMinus
                            }
                            className={classes.cardButtonIcon}
                          />
                        </Button>
                      </Tippy>
                    </div>

                    {/* Container for the Graphic Toggler/Table */}
                    <div
                      style={{
                        position: "absolute",
                        right: "0px",
                        top: "10px",
                        zIndex: 1000,
                      }}
                    >
                      <Tippy
                        content={
                          viewModeCaptura === "chart"
                            ? t("whatshappening.buttons.view_table")
                            : t("whatshappening.buttons.view_chart")
                        }
                        arrow={true}
                        theme="light"
                      >
                        <Button
                          color="client"
                          size="small"
                          variant="outlined"
                          onClick={toggleViewModeCaptura}
                          className={classes.cardButton}
                        >
                          <FontAwesomeIcon
                            icon={
                              viewModeCaptura === "chart"
                                ? faTable
                                : faChartLine
                            }
                            className={classes.cardButtonIcon}
                          />
                        </Button>
                      </Tippy>
                    </div>
                  </CardHeader>
                </GridItem>
                <CardBody
                  style={{
                    flex: 1,
                    overflow: "hidden",
                    marginTop: "-20px",
                    marginBottom: "-10px",
                  }}
                >
                  <MultiSeriesLineChart
                    timeAgg={timeAggCaptura}
                    viewMode={viewModeCaptura}
                    clientColor={clientColor}
                    data={chartDataCapture} // Pass only the monthly or yearly chunk
                    trackingMode={kpiCaptura.trackingMode}
                    thresholdsConfig={kpiCaptura.thresholdsConfig}
                  />
                </CardBody>
              </Card>
            </GridItem>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              style={{ display: "flex", marginTop: "-25px" }}
            >
              <Card
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  height: "24vh",
                }}
              >
                <GridItem>
                  <CardHeader
                    color="client"
                    icon
                    className={classes.cardHeader}
                  >
                    <CardIcon color="client">
                      <AssignmentTurnedIn />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>
                      {t("whatshappening.cards_title.graph_execution")}
                    </h4>

                    {/* Container for Info + Tippy from Mensal/Annual */}
                    <div
                      style={{
                        position: "absolute",
                        right: "40px",
                        top: "10px",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Tooltip
                        title={
                          <span
                            dangerouslySetInnerHTML={{
                              __html: formatThresholds(kpiExecucao),
                            }}
                          />
                        }
                        arrow
                      >
                        <Info
                          style={{
                            fontSize: "18px",
                            color: "#666",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                      <Tippy
                        content={
                          timeAggExecucao === "monthly"
                            ? t("whatshappening.buttons.view_yearly")
                            : t("whatshappening.buttons.view_monthly")
                        }
                        arrow={true}
                        theme="light"
                      >
                        <Button
                          color="client"
                          size="small"
                          variant="outlined"
                          onClick={toggleTimeAggExecucao}
                          className={classes.cardButton}
                        >
                          <FontAwesomeIcon
                            icon={
                              timeAggExecucao === "monthly"
                                ? faCalendarPlus
                                : faCalendarMinus
                            }
                            className={classes.cardButtonIcon}
                          />
                        </Button>
                      </Tippy>
                    </div>

                    {/* Container for the Graphic Toggler/Table */}
                    <div
                      style={{
                        position: "absolute",
                        right: "0px",
                        top: "10px",
                        zIndex: 1000,
                      }}
                    >
                      <Tippy
                        content={
                          viewModeExecucao === "chart"
                            ? t("whatshappening.buttons.view_table")
                            : t("whatshappening.buttons.view_chart")
                        }
                        arrow={true}
                        theme="light"
                      >
                        <Button
                          color="client"
                          size="small"
                          variant="outlined"
                          onClick={toggleViewModeExecucao}
                          className={classes.cardButton}
                        >
                          <FontAwesomeIcon
                            icon={
                              viewModeExecucao === "chart"
                                ? faTable
                                : faChartLine
                            }
                            className={classes.cardButtonIcon}
                          />
                        </Button>
                      </Tippy>
                    </div>
                  </CardHeader>
                </GridItem>
                <CardBody
                  style={{
                    flex: 1,
                    overflow: "hidden",
                    marginTop: "-20px",
                    marginBottom: "-10px",
                  }}
                >
                  <MultiSeriesLineChart
                    timeAgg={timeAggExecucao}
                    viewMode={viewModeExecucao}
                    clientColor={clientColor}
                    data={chartDataExec} // Pass only the monthly or yearly chunk
                    trackingMode={kpiExecucao.trackingMode}
                    thresholdsConfig={kpiExecucao.thresholdsConfig}
                  />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
}
